import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../../common/Table';
import ConstElement from '../../common/ConstElement';
import HasPermission from '../../helper/user.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
                job: {work_start_date: null, work_end_date: null,},
                cities:[],
                prefs:[],
                bigCategories:[],
                smallCategories:[],
                hasPermissionCancel:false,
                job_applys: [],
                selected_bulk_comment_job_apply_ids:[],
                check_count:0,
                bulk_comment_flag:0,
                message_all_checked:false,
                current_message:"",
                disabledSendMessageButton:false,
        }
        this.saveData = this.saveData.bind(this);
        this.deleteJob = this.deleteJob.bind(this);
        this.renderDeleteBtn = this.renderDeleteBtn.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleChangeEditWorkStartDate = this.handleChangeEditWorkStartDate.bind(this);
        this.handleChangeEditWorkEndDate = this.handleChangeEditWorkEndDate.bind(this);
        this.handleHoujinCalculate = this.handleHoujinCalculate.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCopyJob = this.handleCopyJob.bind(this);
        this.renderJobImages = this.renderJobImages.bind(this);
        this.getJobById = this.getJobById.bind(this);
        this.getJobApplys = this.getJobApplys.bind(this);
        this.processClassStatus = this.processClassStatus.bind(this);
        this.processStatus = this.processStatus.bind(this);
        this.generateJobApplyStatus = this.generateJobApplyStatus.bind(this);
        this.saveJobAppliesStatus = this.saveJobAppliesStatus.bind(this);
        this.setGoogleMapSrc = this.setGoogleMapSrc.bind(this);
        this.handlePublicationTypeChange = this.handlePublicationTypeChange.bind(this);
        this.handleChangeEditPostPeriodStartDate = this.handleChangeEditPostPeriodStartDate.bind(this);
        this.handleChangeEditPostPeriodEndDate = this.handleChangeEditPostPeriodEndDate.bind(this);
        this.handleChangeMessageBulk = this.handleChangeMessageBulk.bind(this);
        this.handleCheckAllBulkMessage = this.handleCheckAllBulkMessage.bind(this);
        this.handleCheckMessage = this.handleCheckMessage.bind(this);
        this.countMessageChecked = this.countMessageChecked.bind(this);
        this.createMessage = this.createMessage.bind(this);
        this.handleInputMessageChange = this.handleInputMessageChange.bind(this);
    }

    handleInputMessageChange(event) {
        this.setState({current_message: event.target.value});
    }
    // 一括メッセージ送信
    createMessage() {

        let current_message = this.state.current_message;
        let job_applys = this.state.job_applys;
        let disabledSendMessageButton = this.state.disabledSendMessageButton;

        // let thread_id = this.props.messages[0].message_thread_id;
        let request = {
            // thread_id: thread_id,
            current_message: current_message,
            job_applys: job_applys,
        };
        

        if(current_message && this.state.check_count &&!disabledSendMessageButton){
            this.setState({disabledSendMessageButton: true});
            axios.post('/api/houjin/message_detail_bulk/create', request).then(response => {
                if (response.data.success) {
                    // let newMessages = this.state.messages;
                    // newMessages[response.data.content.id] = response.data.content;
                    toast.success(response.data.message);
                    this.setState({
                        current_message: '',
                        // messages: newMessages
                    });
                }
                this.setState({disabledSendMessageButton: false});
            });
        }

    }
    /**
     * Init data
     */
    componentWillMount() {
        var callback = () => {
            if (this.state.prefs && this.state.cities && this.state.job.pref && this.state.job.city) {
                this.setGoogleMapSrc(this.state.job);
            }
        };

        axios.get('/api/cities').then(response => {
            this.setState({
                cities: response.data
            },callback);
        })
        axios.get('/api/prefs').then(response => {
            this.setState({
                prefs: response.data
            },callback);
        })
        axios.get('/api/big-categories').then(response => {
            this.setState({
                bigCategories: response.data
            });
        })
        axios.get('/api/small-categories').then(response => {
            this.setState({
                smallCategories: response.data
            });
        })

        if (this.props.match.params.hasOwnProperty('id')) {
            this.getJobById(callback);
        }
    }
    setGoogleMapSrc(job) {
        let googleMapParam = ''
        let tokyoPrefId = [13, 14];
        let pref = this.state.prefs.filter(pref => pref.id == job.pref)[0]
        let city = this.state.cities.filter(city => city.id == job.city)[0]

        if (!pref || !city) {
            return;
        }

        if (tokyoPrefId.indexOf(job.pref) >= 0) {
            googleMapParam = `東京都${city.name}${job.address}`
        } else {
            googleMapParam = `${pref.name}${city.name}${job.address}`
        }
        let src = `https://maps.google.co.jp/maps?q=${googleMapParam}&z=18&output=embed&iwloc=J&t=m`;
        this.setState({ src: src });
    }

    /**
     * Get job applys
     */
    getJobApplys() {
        axios.get('/api/houjin/jobs/job-applys/' + this.props.match.params.id).then(response => {
            let jobApplys = response.data.map(jobApply => {
                if (jobApply['status'] == null) {
                    jobApply['status'] = 'NULL';
                }
                return jobApply;
            });
            this.setState({
                job_applys: jobApplys
            })
        });
    }

    /**
     * Get job by id
     */
    getJobById(callback) {
        const jobId = this.props.match.params.id
        axios.get('/api/houjin/jobs/' + jobId).then(response => {
            if (response.data) {
                this.setData(response.data);
                if (callback) {
                    callback
                }
            }
            this.getJobApplys();
        }).catch(() => {
            this.props.history.push('/houjin/home');
        })
    }

    /**
     * Process change work start date
     */
    handleChangeEditWorkStartDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['work_start_date'] = date;
        this.setState({job: jobData});
    }

    /**
     * Process change work end date
     */
    handleChangeEditWorkEndDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['work_end_date'] = date;
        this.setState({job: jobData});
    }

    /**
     * Process change staff_total basis
     */
    handleCalculate(event) {
        let jobData = Object.assign({}, this.state.job);
        jobData['staff_price'] = event.target.value;
        jobData['system_fee'] = Math.floor(jobData['staff_price'] * (this.state.job.system_fee_per / 100));
        jobData['staff_total'] = +jobData['staff_price'] + +jobData['system_fee'];
        this.setState({job: jobData});
    }

    /**
     * Process change staff_price basis
     */
    handleHoujinCalculate(event) {
        let jobData = Object.assign({}, this.state.job);
        // let staff_price_per = (100 - this.state.job.system_fee_per) / 100;
        jobData['staff_price'] = event.target.value;
        jobData['system_fee'] = Math.floor(jobData['staff_price'] * (this.state.job.system_fee_per / 100));
        jobData['staff_total'] = +jobData['staff_price'] + +jobData['system_fee'];
        this.setState({job: jobData});
    }

    /**
     * Set data of job
     * data: Object Job
     */
    setData(data) {
        this.setState({
            job: data
        })
    }

    /**
     * Get data of job
     */
    getData() {
        return this.state.job;
    }

    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event) {
        let jobData = Object.assign({}, this.state.job);
        jobData[event.target.name] = event.target.value;
        switch (event.target.name) {
            case 'free_category':
                jobData['category_type'] = 2
                break;
            case 'big_category':
                jobData['category_type'] = 1
                break;
            case 'small_category':
                jobData['category_type'] = 1
                break;
            default:
                break;
        }
        this.setState({job: jobData});
    }
    handlePublicationTypeChange(event) {
        let jobData = Object.assign({}, this.state.job);
        //set request time
        // 期間指定型はstaff_countは1人固定
        jobData['staff_count'] = 1;
        jobData[event.target.name] = event.target.value;
        this.setState({job: jobData});
    }
    handleChangeEditPostPeriodStartDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['post_period_start_date'] = date;
        this.setState({job: jobData});
    }
    handleChangeEditPostPeriodEndDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['post_period_end_date'] = date;
        this.setState({job: jobData});
    }

    /**
     * Listen change status
     * event: Object input
     */
    handleStatusChange(index, event) {
        let jobApplies = this.state.job_applys;
        jobApplies[index]['status'] = parseInt(event.target.value);
        this.setState({job_applys: jobApplies})
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    /**
     * Handle redirect with job params
     */
    handleCopyJob(e) {
        e.preventDefault();
        let copy_data = this.state.job;
        //reset some value
        copy_data['status'] = 1;
        copy_data['is_copy'] = true;
        copy_data['work_start_date'] = null;
        copy_data['work_end_date'] = null;
        copy_data['request_time_type'] = this.state.job.work_start_time && this.state.job.work_start_time === '時間指定なし' ? 2 : 1;
        copy_data['work_start_time'] = this.state.job.work_start_time && this.state.job.work_start_time !== '時間指定なし' ? this.state.job.work_start_time : '09:00';
        copy_data['work_end_time'] = this.state.job.work_end_time && this.state.job.work_end_time !== '時間指定なし' ? this.state.job.work_end_time : '10:00';
        copy_data['old_images'] = this.state.job.images;
        copy_data['system_fee_per'] = this.state.job.clientSystemFeePer;
        copy_data['system_fee'] = Math.floor(copy_data['staff_price'] * (copy_data['system_fee_per'] / 100));
        copy_data['staff_total'] = +copy_data['staff_price'] + +copy_data['system_fee'];
        copy_data['post_period_start_date'] = null;
        copy_data['post_period_end_date'] = null;
        copy_data['post_period_start_time'] = this.state.job.post_period_start_time ? this.state.job.post_period_start_time : '08:00';
        copy_data['post_period_end_time'] = this.state.job.post_period_end_time ? this.state.job.post_period_end_time : '18:00';

        this.props.history.push({
            pathname: e.currentTarget.getAttribute('href'),
            state: { copy_data: copy_data }
        });
    }

    /**
     * Call function save data from element parent
     */
    saveData() {
        let job = this.getData();
        //to top
        window.scrollTo(0, 0)
        if (job.hasOwnProperty('id')) {
            axios.post('/api/houjin/jobs/edit/' + job.id, job)
            .then(response => {
                if (response.data.success) {
                    toast.success(response.data.message);
                    this.getJobById();
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    renderDeleteBtn() {
        // カウント0or不採用で条件変える
        const rejectJobApplys = this.state.job_applys.filter((jobApply) => {
            return jobApply.status == 2
        })
        if (this.state.job.status !== 9 && (this.state.job_applys.length == 0 || rejectJobApplys.length === this.state.job_applys.length)) {
            return (
                <button onClick={this.deleteJob} className="btn btn-danger btn-radius btn-lg clearfix"><span className="size-inherit">依頼キャンセル</span></button>
            );
        }
        return;
    }

    deleteJob() {
        window.scrollTo(0, 0)
        if (window.confirm('依頼キャンセルしてもよろしいですか。')) {
            let job = this.getData();
            if (job.hasOwnProperty('id')) {
                axios.delete('/api/houjin/jobs/' + job.id)
                .then(res => {
                    this.props.history.push('/houjin/jobs');
                }).catch(error => {
                    Object.keys(error.response.data.errors).map((key, i) => {
                            if($.isArray(error.response.data.errors[key])){
                                error.response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(error.response.data.errors[key])
                            }
                        }
                    )
                })
            }
        }
    }

    /**
     * Handle class with status
     */
    processClassStatus(status) {
        switch(status) {
            case 1:
                return "badge badge-info mr-1";
            case 2:
                return "badge badge-danger mr-1";
            case 3:
                return "badge badge-warning text-white mr-1";
            case 9:
                return "badge badge-dark mr-1";
            default:
                return "badge badge-secondary mr-1";
        }
    }

    /**
     * Handle show text with status
     */
    processStatus(status) {
        switch(status) {
            case 1:
                return "採用";
            case 2:
                return "不採用";
            case 3:
                return "欠勤";
            case 9:
                return "応募キャンセル";
            default:
                return "未決定";
        }
    }

    /**
     * Generate JobApply status option
     */
    generateJobApplyStatus(jobApply, index) {
        let job = this.getData();
        let options = [
            {value: 'NULL', label: '未決定', disabled: jobApply.disable_status.not_set},
            {value: 1, label: '採用', disabled: jobApply.disable_status.accepted},
            {value: 2, label: '不採用', disabled: jobApply.disable_status.rejected},
            {value: 3, label: '欠勤', disabled: jobApply.disable_status.not_work},
        ];

        // If finish eveluation no need to change job apply status
        let isFinishedEvaluation = !!(jobApply.evaluation_staff && jobApply.evaluation_client);

        if (isFinishedEvaluation == false) {
            // If job apply status is reject and job status is waiting evaluation
            // no need to change job apply status
            isFinishedEvaluation = jobApply.status == 2 && job.status == 4;
        }

        return (
            <select
              onChange={(event) => {
                this.handleStatusChange(index, event);
              }}
              disabled={isFinishedEvaluation}
              value={jobApply.status}
              className="form-control"
            >
                {options.map((option, i) => {
                    return <option key={i} value={option.value} disabled={option.disabled} style={option.style}>
                        {option.label}
                    </option>;
                })}
            </select>
        );
    }

    renderJobImages() {
        let images = [
            '/img/detail_1.png',
        ];

        if (this.state.job.images_path && this.state.job.images_path.length) {
            images = this.state.job.images_path;
        }

        return (
            <div className="form-group row">
                <label className="col-4 col-sm-2 col-form-label pr-0">
                    <span className="h5 font-weight-normal">
                        依頼画像
                        {/* <br />
                        <span className="small">※3枚まで登録可能</span><br/>
                        <span className="small">※メイン画像に<br className="d-block d-sm-none" />チェック
                        </span> */}
                    </span>
                </label>
                <div className="col-8 col-sm-10">
                    {images.map((img, index) => {
                        return (
                            <div class="row pb-2">
                                <div class="col-sm-6">
                                    <div
                                        key={index}
                                        style={{ maxWidth: 200, maxHeight: 'auto' }}
                                        className="my-auto d-flex justify-content-center align-items-center"
                                    >
                                        <img src={img} className="imagePreview img-thumbnail ml-1 mr-1 mb-2" />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderStatus(){
        //special cases
        if (!this.state.job.status){
            return React.createElement(
                    'select',
                    {onChange: this.handleInptChange, name: 'status', value: this.state.job.status ? this.state.job.status : '', className: 'form-control', readOnly: true},
                    React.createElement("option", {value: 'NULL'}, "掲載確認中"),
                );
        }
        if (this.state.job.status == 1 && this.state.job.apply_count == 0){
            return React.createElement(
                    'select',
                    {onChange: this.handleInptChange, name: 'status', value: this.state.job.status, className: 'form-control'},
                    React.createElement("option", {value: 1}, "掲載中"),
                    React.createElement("option", {value: 9}, "依頼キャンセル")
                );
        }
        if (this.state.job.status == 1 && this.state.job.apply_count > 0){
            return React.createElement(
                    'select',
                    {onChange: this.handleInptChange, name: 'status', value: this.state.job.status, className: 'form-control', readOnly: true},
                    React.createElement("option", {value: 1}, "掲載中"),
                );
        }

        //normal cases
        const status_arr = {
            2: "掲載終了",
            3: "就業中",
            4: "評価待ち",
            5: "作業完了",
            6: "未採用",
            7: "仲裁",
            8: "欠勤",
            9: '依頼キャンセル'
        }
        return React.createElement(
                'select',
                {onChange: this.handleInptChange, name: 'status', value: this.state.job.status, className: 'form-control', readOnly: true},
                React.createElement("option", {value: this.state.job.status}, status_arr[this.state.job.status])
            );
    }

    saveJobAppliesStatus() {
        let job = this.getData();
        let payload = this.state.job_applys.map((jobApply) => {
          return {
            id: jobApply.job_applys_id,
            status: jobApply.status,
          };
        });

        axios.put("/api/houjin/jobapplys/edit-status/" + job.id, {jobAppliesStatus: payload})
            .then((response) => {
                if (response.data.success) {
                    this.getJobById();
                    this.getJobApplys();
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.error_messages)
                }
            });
    }

    /**
     * 一括メッセージ切り替え
     */
    handleChangeMessageBulk(e) {
        e.preventDefault()
        this.setState({bulk_comment_flag: !this.state.bulk_comment_flag})
    }

    handleCheckAllBulkMessage(e) {
            let jobApplies = this.state.job_applys;
            jobApplies = jobApplies.map(jobApply => {
                if(jobApply.status != 2 && jobApply.status != 9 && !jobApply.deleted_at && (!jobApply.evaluation_staff || !jobApply.evaluation_client)) {
                    jobApply['message_checked'] = e.target.checked;
                } else {
                    jobApply['message_checked'] = false;
                }
                return jobApply;
            });

            this.setState({job_applys: jobApplies})
    
        this.setState({message_all_checked: e.target.checked})

        this.countMessageChecked()
    }

    handleCheckMessage(e, index) {
        let jobApplies = this.state.job_applys;
        jobApplies[index]['message_checked'] = e.target.checked;
        this.setState({job_applys: jobApplies})

        this.countMessageChecked()
    }

    countMessageChecked() {
        let jobApplies = this.state.job_applys;
        let jobAppliesFilter = jobApplies.filter(jobApply => 
            jobApply['message_checked'] == true
        );
        this.setState({check_count: jobAppliesFilter.length})
    }

    render() {
        const src = this.state.src
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/jobs">依頼一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">依頼編集</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                            <div className="card">
                                <div className="card-header p-4 border-bottom-0">
                                    <div className="row">
                                        <div className="col"><h4 className="mb-0">依頼編集</h4></div>
                                        <div className="col text-right">
                                            <a onClick={this.handleCopyJob} href="/houjin/jobs/create" className="btn btn-warning btn-space font-weight-normal">依頼コピー</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label font-size"><p className="h5 font-weight-normal">契約形態</p></label>
                                        <div className="col-8 col-sm-10 pt-2">
                                            <span className={this.state.job.payment_method == 1 ? 'mt-1 h5 font-weight-normal' : 'mt-1 h5 font-weight-normal'}>{this.state.job.payment_method == 1 ? '委任' : '直雇用'}</span>
                                        </div>
                                    </div>
                                    {/* <div className="form-group row">
                                        <label className="col-4 col-sm-3 col-form-label">タイトル</label>
                                        <div className="col-sm-10">
                                            <span className={this.state.job.category_type==1 ? 'badge bg-pink text-white mt-1' : 'badge bg-purple text-white mt-1'}>{this.state.job.category_type==1 ? 'カテゴリで選ぶ' : '入力する'}</span>
                                        </div>
                                    </div> */}

                                    <div className="mb-4 mb-sm-2">
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">タイトル</p></label>
                                            <div className="col-sm-10">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'free_category', value: this.state.job.free_category || "", className: 'form-control', disabled: 'disabled'},
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">大カテゴリ</p></label>
                                            <div className="col-8 col-sm-5">
                                                <select onChange={this.handleInptChange} name="big_category_id" value={this.state.job.big_category_id ? this.state.job.big_category_id : ''} className="form-control" disabled >
                                                    {this.state.bigCategories.map((dataRow, i) => {
                                                        return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">小カテゴリ</p></label>
                                            <div className="col-8 col-sm-5">
                                                <select onChange={this.handleInptChange} name="small_category_id" value={this.state.job.small_category_id ? this.state.job.small_category_id : ''} className="form-control" disabled >
                                                    {this.state.smallCategories.filter(small_category_id => small_category_id.big_category_id == this.state.job.big_category_id).map((dataRow, i) => {
                                                        return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">作業日</p></label>
                                        <div className="col-8 col-sm-8 pt-2">
                                            <div className="row">
                                                <div className="col-12 col-sm-3">
                                                    <input onChange={this.handlePublicationTypeChange} value="2" type="radio" name="publication_type" id="publication_type2" checked={this.state.job.publication_type == 2 || this.state.job.publication_type == null ? 'checked' : ''} disabled/>
                                                    <label htmlFor="publication_type2" className="ml-1 mr-3"><p className="h5 font-weight-normal">期間指定</p></label>
                                                </div>
                                                <div className="col-12 col-sm-3">
                                                    <input onChange={this.handlePublicationTypeChange} value="1" type="radio" name="publication_type" id="publication_type1" checked={this.state.job.publication_type == 1 ? 'checked' : ''} disabled/>
                                                    <label htmlFor="publication_type1" className="ml-1 text-black-50"><p className="h5 font-weight-normal">日付指定</p></label>
                                                </div>
                                            </div>
                                            <div>
                                                <span>期間指定では、期間中に1回作業を依頼します。</span>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.job.publication_type == 2 ? (
                                    <>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 form-label text-left" htmlFor=""><p className="h5 font-weight-normal">期間</p></label>
                                                {/* <DatePicker
                                                    locale="ja-JP"
                                                    className="form-control form_datepicker"
                                                    dateFormat="YYYY/MM/DD"
                                                    selected={this.state.job.post_period_start_date ? moment(new Date(this.state.job.post_period_start_date)) : null}
                                                    onChange={this.handleChangeEditPostPeriodStartDate}
                                                    minDate={moment()}
                                                    // maxDate={moment().add(30, 'days')}
                                                    placeholderText="例）2023/02/01 ～ 2023/02/28"
                                                    disabledKeyboardNavigation
                                                    onChangeRaw={this.handleDateChangeRaw}
                                                    startDate={this.state.job.post_period_start_date}
                                                    endDate={this.state.job.post_period_end_date}
                                                    selectsRange
                                                /> */}
                                            <div class="col-9 col-sm-10 row">
                                                <div className="col-8 col-sm-4 input-group mb-3">

                                                    <DatePicker
                                                        locale="ja-JP"
                                                        className="form-control form_datepicker"
                                                        dateFormat="YYYY/MM/DD"
                                                        selected={moment(new Date(this.state.job.post_period_start_date))}
                                                        selectsStart
                                                        onChange={this.handleChangeEditPostPeriodStartDate}
                                                        // minDate={moment()}
                                                        placeholderText="2023/02/01"
                                                        disabledKeyboardNavigation
                                                        startDate={moment(new Date(this.state.job.post_period_start_date))}
                                                        endDate={moment(new Date(this.state.job.post_period_end_date))}
                                                        disabled
                                                    />
                                                    <div className="input-group-append job-input-group-append">
                                                        <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                    </div>
                                                </div>
                                                <div className="pt-1 text-center">
                                                    <span>～</span>
                                                </div>
                                                <div className="col-8 col-sm-4 input-group">
                                                    <DatePicker
                                                        locale="ja-JP"
                                                        className="form-control form_datepicker"
                                                        dateFormat="YYYY/MM/DD"
                                                        selected={moment(new Date(this.state.job.post_period_end_date))}
                                                        selectsEnd
                                                        onChange={this.handleChangeEditPostPeriodEndDate}
                                                        // minDate={moment()}
                                                        placeholderText="2023/02/28"
                                                        disabledKeyboardNavigation
                                                        startDate={moment(new Date(this.state.job.post_period_start_date))}
                                                        endDate={moment(new Date(this.state.job.post_period_end_date))}
                                                        disabled
                                                    />
                                                    <div className="input-group-append job-input-group-append">
                                                        <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row row-cols-3 mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">時間帯</p></label>
                                            <div className="col-3 col-sm-2 mb-3 pr-0">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'post_period_start_time', value: this.state.job.post_period_start_time|| "", className: 'form-control', disabled: 'disabled'},
                                            )}
                                            </div>
                                            <div className="pt-1 text-center pr-3 pl-3">
                                                <span>～</span>
                                            </div>
                                            <div className="col-3 col-sm-2 pl-0">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'post_period_end_time', value: this.state.job.post_period_end_time|| "", className: 'form-control', disabled: 'disabled'},
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">作業時間<br className="d-block d-sm-none"/>(目安)</p></label>
                                            <div className="col-8 col-sm-10">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'approximate_time', value: this.state.job.approximate_time|| "", className: 'form-control', placeholder: '15分', disabled: 'disabled'}
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group row mb-4">
                                            <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">時間帯コメント</p></label>
                                            <div className="col-sm-10">
                                                <textarea onChange={this.handleInptChange} name="approximate_time_comment" value={this.state.job.approximate_time_comment ? this.state.job.approximate_time_comment : ''} className="form-control" rows="10" disabled></textarea>
                                            </div>
                                        </div>
                                        {/* <div className="form-group row">
                                            <label className="col-4 col-sm-3 col-form-label">完了報告</label>
                                            <div className="col-sm-10">
                                                <input onChange={this.handleInptChange} value="1" type="radio" name="need_finish_report_flg" id="need_finish_report_flg1" checked={this.state.job.need_finish_report_flg == 1 ? 'checked' : ''} disabled/>
                                                <label htmlFor="need_finish_report_flg1" className="ml-1 mr-3">必要</label>
                                                <input onChange={this.handleInptChange} value="0" type="radio" name="need_finish_report_flg" id="need_finish_report_flg2" checked={this.state.job.need_finish_report_flg == 0 ? 'checked' : ''} disabled/>
                                                <label htmlFor="need_finish_report_flg2" className="ml-1">不要</label>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-4 col-sm-3 col-form-label">報告ガイドテキスト</label>
                                            <div className="col-sm-10">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'finish_report_guide_line_text', value: this.state.job.finish_report_guide_line_text|| "", className: 'form-control', placeholder: '', disabled: 'disabled'},
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-4 col-sm-3 col-form-label">報告ガイドリンク先URL</label>
                                            <div className="col-sm-10">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'finish_report_guide_line_url', value: this.state.job.finish_report_guide_line_url|| "", className: 'form-control', placeholder: '', disabled: 'disabled'},
                                                )}
                                            </div>
                                        </div> */}
                                    </>
                                    ): (
                                    <>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label" htmlFor=""><p className="h5 font-weight-normal">勤務日</p></label>
                                            <div className="col-8 col-sm-5">
                                                <DatePicker
                                                    locale="ja-JP"
                                                    className="form-control form_datepicker"
                                                    dateFormat="YYYY/MM/DD"
                                                    selected={moment(new Date(this.state.job.work_start_date))}
                                                    onChange={this.handleChangeEditWorkStartDate}
                                                    placeholderText="勤務開始日"
                                                    disabledKeyboardNavigation
                                                    disabled
                                                />
                                                <div className="input-group-append job-input-group-append">
                                                    <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">勤務開始時間</p></label>
                                            <div className="col-8 col-sm-5">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'work_start_time', value: this.state.job.work_start_time|| "", className: 'form-control', disabled: 'disabled'},
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group row mb-4 mb-sm-2">
                                            <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">勤務終了時間</p></label>
                                            <div className="col-8 col-sm-5">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'work_end_time', value: this.state.job.work_end_time|| "", className: 'form-control', disabled: 'disabled'},
                                                )}
                                            </div>
                                        </div>
                                    </>
                                    )}
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">郵便番号</p></label>
                                        <div className="col-8 col-sm-3">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'zip_no', value: this.state.job.zip_no|| "", className: 'form-control', disabled: 'disabled'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">都道府県</p></label>
                                        <div className="col-8 col-sm-5">
                                            <select onChange={this.handleInptChange} name="pref" value={this.state.job.pref ? this.state.job.pref : ''} className="form-control" disabled>
                                            {this.state.prefs.map((dataRow, i) => {
                                                return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                            })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">市区</p></label>
                                        <div className="col-8 col-sm-5">
                                            <select onChange={this.handleInptChange} name="city" value={this.state.job.city ? this.state.job.city : ''} className="form-control" disabled>
                                                {this.state.cities.filter(city => city.pref_id == this.state.job.pref).map((dataRow, i) => {
                                                    return <option key={i} value={dataRow.id}>{dataRow.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label" htmlFor=""><p className="h5 font-weight-normal">町名・番地</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'address', value: this.state.job.address|| "", className: 'form-control', disabled: 'disabled'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">ビル・建物名</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'address2', value: this.state.job.address2|| "", className: 'form-control', disabled: 'disabled'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-sm-2 col-form-label" htmlFor=""><p className="h5 font-weight-normal">マップ自動連携</p></label>
                                        <div className="col-sm-7">
                                            <span>上記の住所に合わせてピンを自動設定しております。</span>
                                            <div className="row mt-3 mb-2">
                                                <div className="col-12 col-sm-6">
                                                    <input
                                                        // onChange={this.handleMapLinkage}
                                                        value="1"
                                                        type="radio"
                                                        name="use_map_flg"
                                                        id="use_map_flg1"
                                                        checked={this.state.job.use_map_flg == 1 ? 'checked' : ''}
                                                        disabled
                                                    />
                                                    <label htmlFor="use_map_flg1" className="ml-1 mr-3"><p className="h5 font-weight-normal">このマップを使用する</p></label>
                                                </div>
                                                <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                    <input
                                                        // onChange={this.handleMapLinkage}
                                                        value="0"
                                                        type="radio"
                                                        name="use_map_flg"
                                                        id="use_map_flg2"
                                                        checked={this.state.job.use_map_flg == 0 ? 'checked' : ''}
                                                        disabled
                                                    />
                                                    <label htmlFor="use_map_flg2" className="ml-1"><p className="h5 font-weight-normal">このマップを使用しない</p></label>
                                                </div>
                                            </div>
                                            <div className="">
                                                <iframe frameborder="0" scrolling="auto" marginheight="0" marginwidth="0" src={src} className="w-100"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">最寄駅</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'station_name', value: this.state.job.station_name|| "", className: 'form-control', disabled: 'disabled'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">最寄駅まで</p></label>
                                        <div className="col-8 col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'to_station', value: this.state.job.to_station|| "", className: 'form-control', disabled: 'disabled'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">詳細</p></label>
                                        <div className="col-sm-10">
                                            <textarea onChange={this.handleInptChange} name="note" value={this.state.job.note ? this.state.job.note : ''} className="form-control" rows="16" disabled></textarea>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">詳細補足URL</p></label>
                                        <div className="col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'job_description_url', value: this.state.job.job_description_url|| "", className: 'form-control', placeholder: '',disabled: 'disabled'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4">
                                        <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">リンクテキスト</p></label>
                                        <div className="col-sm-10">
                                            {
                                                React.createElement(
                                                    'input',
                                                    {type: 'text', onChange: this.handleInptChange, name: 'job_description_text', value: this.state.job.job_description_text|| "", className: 'form-control', placeholder: '',disabled: 'disabled'},
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4">
                                        <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">入職経路</p></label>
                                        <div className="col-sm-10">
                                            <textarea onChange={this.handleInptChange} name="job_detail" value={this.state.job.job_detail ? this.state.job.job_detail : ''} className="form-control" rows="8"></textarea>
                                        </div>
                                    </div>
                                    <div className="form-group row mb-4 mb-sm-2">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">ステータス</p></label>
                                        <div className="col-8 col-sm-5">
                                            {this.renderStatus()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label"><p className="h5 font-weight-normal">募集人数</p></label>
                                        <div className="col-8 col-sm-8 pt-1">
                                        {this.state.job.publication_type == 2 ? (
                                            <label class="col-value text-left">1人</label>
                                        ):(

                                            <div className="input-group">
                                                {
                                                    React.createElement(
                                                        'input',
                                                        {type: 'text', onChange: this.handleInptChange, name: 'staff_count', value: this.state.job.staff_count, className: 'form-control', disabled: this.state.job.status !== 1},
                                                )}
                                                <div className="input-group-append">
                                                    <span className="input-group-text">人</span>
                                                </div>
                                            </div>
                                        )}
                                        </div>
                                        {this.state.job.publication_type == 2 ? '' : (
                                            <div className="col-sm-8 offset-sm-4 text-center text-danger">
                                                <span>※1～99人で設定が可能です。</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">募集金額</p><span className="text-danger font-weight-normal">※日給</span></label>
                                        <div className="col-8 col-sm-8 pt-1">
                                            {this.state.job_applys.length == 0 && this.state.job.status == 1 ?
                                            //no apply and status  = 1
                                                    React.createElement(
                                                        'input',
                                                        {type: 'number', onChange: this.handleHoujinCalculate, placeholder: '金額は10円単位で設定可能です', name: 'staff_price', value: this.state.job.staff_price, className: 'form-control'},
                                                        ):
                                            //applied
                                                 <label className="col-value text-left">{this.state.job.staff_price ? '¥' + parseInt(this.state.job.staff_price).toLocaleString() : ''}</label>
                                                    }
                                        </div>
                                        {this.state.job_applys.length == 0 && this.state.job.status == 1 && //no apply and status  = 1
                                            <div className="col-sm-8 offset-sm-4">
                                                <span>10円単位で入力してください。</span>
                                            </div>
                                        }
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className=" h5 font-weight-normal">システム利用料</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{'¥' + parseInt(this.state.job.system_fee).toLocaleString()}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">システム利用料%</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left"><p className="h5 font-weight-normal">{this.state.job.system_fee_per + '%'}</p></label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">お支払い金額（税抜）</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{this.state.job.staff_total ? '¥' + parseInt(this.state.job.staff_total).toLocaleString() : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">応募人数</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{this.state.job.apply_count ? this.state.job.apply_count + '人' : '0人'}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">採用人数</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{this.state.job.recruit_count ? this.state.job.recruit_count + '人' : '0人'}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">作成日</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{moment(this.state.job.created_at).format('YYYY-MM-DD HH:mm')}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-4 col-sm-2 col-form-label pr-0"><p className="h5 font-weight-normal">編集日</p></label>
                                        <div className="col-8 col-sm-10">
                                            <label className="col-value text-left">{moment(this.state.job.updated_at).format('YYYY-MM-DD HH:mm')}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label"><p className="h5 font-weight-normal">依頼メモ</p></label>
                                        <div className="col-sm-10">
                                            <textarea onChange={this.handleInptChange} name="client_memo" value={this.state.job.client_memo ? this.state.job.client_memo : ""}  className="form-control" rows="8"></textarea>
                                        </div>
                                    </div>
                                    {this.renderJobImages()}
                                </div>
                            </div>

                            <div className="row mb-5">
                                <div className="col-sm-12">
                                    <div className="card-footer">
                                        <div className="text-center">
                                            <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">保存</span></button>
                                            {this.renderDeleteBtn()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card mt-3">
                                <div className="card-header p-4 border-bottom-0">
                                    <div className="row">
                                        <div className="col"><h4 className="mb-0">応募者一覧</h4></div>
                                        <div className="col text-right">
                                            {this.state.bulk_comment_flag == 0 && this.state.job.status != 5 && this.state.job.status != 9 && (
                                                <button 
                                                onClick={this.handleChangeMessageBulk}
                                                className="btn btn-info text-dark"
                                                style={{ width:"137px", backgroundColor: "#68C3D1", borderColor: "#68C3D1", borderRadius: '4px' }}>一括コメント
                                                <img className="ml-2" src="/img/icons/bulk_comment_icon.png" /></button>
                                            )}
                                            {this.state.bulk_comment_flag != 0 && this.state.job.status != 5 && this.state.job.status != 9 && (
                                                <button 
                                                onClick={this.handleChangeMessageBulk}
                                                className="btn btn-info text-dark"
                                                style={{ width:"137px",backgroundColor: "#68C3D1", borderColor: "#68C3D1", borderRadius: '4px' }}>戻る
                                                <img className="ml-2" src="/img/icons/back_square_icon.png" /></button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                {this.state.bulk_comment_flag == 1 &&
                                    <div style={{width: '100%', height: '100%', background: 'white', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                                        <div style={{flex: '1 1 0', background: '#62B7C5', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', display: 'inline-flex'}}>
                                            <div style={{alignSelf: 'stretch', height: 53, paddingTop: 13, paddingBottom: 12, paddingLeft: 21, paddingRight: 20, background: 'rgba(0, 0, 0, 0.03)', borderTopLeftRadius: 3, borderTopRightRadius: 3, borderTop: '1px rgba(0, 0, 0, 0.12) solid', justifyContent: 'flex-start', alignItems: 'center', gap: 9, display: 'inline-flex'}}>
                                                <div style={{paddingLeft: 10, paddingRight: 10, paddingTop: 12, paddingBottom: 12, justifyContent: 'flex-start', alignItems: 'center', gap: 9, display: 'flex'}}>
                                                    <input style={{width: 20, height: 20, position: 'relative', background: 'white', borderRadius: 3, border: '1px #222222 solid'}} 
                                                    class="form-check-input" 
                                                    type="checkbox" 
                                                    checked={this.state.message_all_checked}
                                                    onChange={this.handleCheckAllBulkMessage} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                    <div className="list-group">
                                    {this.state.job_applys.length == 0 ? '応募がありません。' :
                                        this.state.job_applys.map((dataRow, i) => {
                                            return <a key={i} className="list-group-item list-group-item-action flex-column align-items-start">
                                                    <div className="w-100 row">
                                                        {this.state.bulk_comment_flag == 1 &&
                                                        (dataRow.status != 2 && dataRow.status != 9 && !dataRow.deleted_at && (!dataRow.evaluation_staff || !dataRow.evaluation_client))
                                                        &&
                                                            <div className="w-100 col-md-1 m-0 d-md-flex mb-md-0 mb-4">
                                                                <input style={{width: 20, height: 20, position: 'relative', background: 'white', borderRadius: 3, border: '1px #222222 solid'}} 
                                                                class="form-check-input" 
                                                                type="checkbox" 
                                                                value={dataRow.job_applys_id}
                                                                checked={dataRow.message_checked}
                                                                onChange={(event) => {this.handleCheckMessage(event, i)}}
                                                                name="job_apply_id[]"
                                                                />
                                                            </div>
                                                        }
                                                        <div className="w-100 col m-0">
                                                            <div className="w-100 row m-0">
                                                                <div className="col-lg-5 col pl-0 mb-3" onClick={this.handleRedirect} href={"/houjin/jobapplys/edit/" + dataRow.job_applys_id}>
                                                                    <h5 className="mb-3">
                                                                        <span className={this.processClassStatus(dataRow.status)}>{this.processStatus(dataRow.status)}</span>
                                                                        <span className="h5 font-weight-normal">{dataRow.nickname} ({dataRow.first_last_name})</span>
                                                                        {dataRow.confirmed_at ? <span className="icon-identification font-weight-normal">本人認証済</span> : ''}
                                                                    </h5>
                                                                    <p className="mb-1 h5 font-weight-normal">{dataRow.birthday_label}　{dataRow.gender_label}</p>
                                                                    <p className="mb-1 h5 font-weight-normal">{dataRow.address}</p>
                                                                </div>
                                                                {this.state.bulk_comment_flag == 0 &&
                                                                <div className="col-lg-3 col-5 pr-0 pl-0 pr-lg-4">
                                                                    {this.generateJobApplyStatus(dataRow, i)}
                                                                </div>
                                                                }
                                                                <div className="col-lg-4 col-12 p-0" onClick={this.handleRedirect} href={"/houjin/jobapplys/edit/" + dataRow.job_applys_id}>
                                                                    <p className="mb-1 mt-lg-2 h5 font-weight-normal">作業予定日：{ dataRow.apply_date }</p>
                                                                </div>
                                                            </div>
                                                            <div className="w-100 row m-0" onClick={this.handleRedirect} href={"/houjin/jobapplys/edit/" + dataRow.job_applys_id}>
                                                                <p className="col-lg-12 col-12 text-left mb-2 pl-0 pr-0">
                                                                    <span className="d-inline-block mr-3 h5 font-weight-normal">評価：{dataRow.evaluation_avg ? dataRow.evaluation_avg.toString().slice(0, 4) : '-'}
                                                                    </span>
                                                                    <span className="d-inline-block mr-3 h5 font-weight-normal">実績：{dataRow.evaluation_count ? dataRow.evaluation_count + '件' : '0件'}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                            <div className="w-100 row" onClick={this.handleRedirect} href={"/houjin/jobapplys/edit/" + dataRow.job_applys_id}>
                                                                {
                                                                    dataRow.status == 3 ? '' :
                                                                    <p class="col-lg-4 col-12 text-left mb-2 text-danger h5 font-weight-normal">
                                                                        {dataRow.status == 1 && this.state.job.status == 4 && !dataRow.evaluation_staff ? '評価待ち' : (dataRow.evaluation_staff ? '評価済み' : '')}
                                                                    </p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                               </a>
                                        })
                                    }
                                    </div>
                                    {this.state.bulk_comment_flag == 1 &&
                                    <div style={{width: '100%', padding: 10, background: '#68C3D1', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end', gap: 10, display: 'inline-flex'}}>
                                        <textarea 
                                            placeholder="コメントする" 
                                            style={{alignSelf: 'stretch', height: 107, paddingTop: 5, paddingBottom: 5, paddingLeft: 5, paddingRight: 5, background: 'white', borderRadius: 8, overflow: 'hidden', border: '1px #6C757D solid', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}
                                            onChange={this.handleInputMessageChange}
                                            value={this.state.current_message}
                                        >
                                        </textarea>
                                        <div style={{flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center', gap: 10, display: 'flex'}}>
                                            <button style={{height:'40px', paddingLeft: 20, paddingRight: 20, paddingTop: 10, paddingBottom: 10, background: 'black', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex', textAlign: 'center', color: 'white', fontSize: 14, fontFamily: 'Osaka', fontWeight: '400', lineHeight: 19.20, wordWrap: 'break-word'}}
                                                onClick={this.createMessage}
                                            >
                                                一括送信 ({this.state.check_count})
                                            </button>
                                        </div>
                                    </div>
                                    }

                                </div>
                            </div>
                            {this.state.job_applys.length > 0 && this.state.bulk_comment_flag == 0 &&
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-footer">
                                            <div className="text-center">
                                                <button onClick={this.saveJobAppliesStatus} disabled={this.disabledSendMessageButton} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">更新</span></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
